import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import AuthenticationFactorListItemActionRegister
  from 'Views/Page/Content/Templates/SettingsTemplate/Content/AuthenticationFactorTemplate/AuthenticationFactorsCard/AuthenticationFactorListPicker/AuthenticationFactorList/Content/AuthenticationFactorListItem/AuthenticationFactorListItemActionPicker/AuthenticationFactorListItemActionRegister';
import AuthenticationFactorListItemAction
  from 'Views/Page/Content/Templates/SettingsTemplate/Content/AuthenticationFactorTemplate/AuthenticationFactorsCard/AuthenticationFactorListPicker/AuthenticationFactorList/Content/AuthenticationFactorListItem/AuthenticationFactorListItemActionPicker/AuthenticationFactorListItemAction';
import PropTypes from 'prop-types';

const AuthenticationFactorListItemActionPicker = ({ authenticationFactorResource }) => {
  return pickFunction(authenticationFactorResource, {
    [fr.relationships.authenticationFactorRegister.name]: () => {
      return (
        <AuthenticationFactorListItemActionRegister authenticationFactorResource={authenticationFactorResource} />
      );
    },
    [fr.relationships.default.name]: () => {
      return (
        <AuthenticationFactorListItemAction authenticationFactorResource={authenticationFactorResource} />
      );
    },
  });
};

AuthenticationFactorListItemActionPicker.propTypes = {
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default AuthenticationFactorListItemActionPicker;
